import types from './ActionTypes';
import httpService from 'services/httpService';
import { store } from 'Store';
// Utils
// import coursesListToMap from 'Utils/CoursesListToMap';
// import instituteListToMap from 'Utils/InstituteListToMap';
// import departmentListToMap from 'Utils/DepartmentListToMap';

// Base URL
import * as constants from 'Constants';
import { addBaseUrl } from 'Store/utils';
import log from "loglevel";


export function getUser() {
    const state = store.getState();
    return state.userInfo;
}

export function loadCoursesListRequest(parameters = null, state = null, limit = 16, offset = 0) {
    return async dispatch => {
        // let coursesListUrl = '/courseware/api/all_courses/' + (parameters ? parameters : '');
        let coursesListUrlCostom = constants.base_url + '/courseware/api/all_courses/?course_info__is_published=True&limit=' + limit;
        if (state) {
            /*
            courseInstitute: null,
            courseDepartment: null,
            searchparam: null
            */
            coursesListUrlCostom += '&institute__name=' + (state.courseInstitute ? state.courseInstitute : '') +
                '&department__name=' + (state.courseDepartment ? state.courseDepartment : '') +
                '&search=' + (state.searchParam ? state.searchParam : '');
        }
        coursesListUrlCostom += '&offset=' + offset;

        const user = getUser();
        try {
            const response = await httpService.get(
                coursesListUrlCostom,
                {
                    headers: {
                        Authorization: `Token ${user.token}`,
                    },
                }
            );
            if (response.status === 200) {
                let paginationInfo = {
                    totalCourses: response.data.count,
                    nextLink: addBaseUrl(response.data.next),
                    prevLink: addBaseUrl(response.data.previous)
                }
                let coursesMap = response.data.results;
                //log.log(coursesMap);
                dispatch(loadCoursesListSuccess(coursesMap));
                dispatch(loadPaginationInfoSuccess(paginationInfo));
            }
        } catch (err) {
            log.log(err);
            throw (err);
        }
    };
};

export function getAllInstitute() {
    return async (dispatch) => {
        const user = getUser();
        try {
            const response = await httpService.get(
                constants.base_url + '/courseware/get_allinstitutes',
                {
                    headers: {
                        Authorization: `Token ${user.token}`,
                    },
                }
            );
            if (response.status === 200) {
                let instituteMap = response.data['institutes'];
                dispatch(loadInstituteListSuccess(instituteMap));
            }
        } catch (err) {
            log.log(err);
            throw (err);
        }
    };
}
export function getAllDepartment() {
    return async dispatch => {
        const user = getUser();
        try {
            const response = await httpService.get(
                constants.base_url + '/courseware/get_alldepartments',
                {
                    headers: {
                        Authorization: `Token ${user.token}`,
                    },
                }
            );
            if (response.status === 200) {
                let departmentsMap = response.data['departments'];
                dispatch(loadDepartmentListSuccess(departmentsMap));
            }
        } catch (err) {
            log.log(err);
            throw (err);
        }
    };
}

export function loadCoursesListSuccess(publicCoursesMap) {
    return { type: types.LOAD_PUBLIC_COURSES_LIST_SUCCESS, publicCoursesMap };
};

export function loadCoursesListFailure() {
    return { type: types.LOAD_PUBLIC_COURSES_LIST_FAILURE };
};

export function loadInstituteListSuccess(instituteList) {
    return { type: types.LOAD_INSTITUTE_LIST_SUCCESS, instituteList };
};
export function loadDepartmentListSuccess(departmentList) {
    return { type: types.LOAD_DEPARTMENT_LIST_SUCCESS, departmentList };
};

export function loadPaginationInfoSuccess(paginationInfo) {
    return { type: types.LOAD_PAGINATION_INFO_SUCCESS, paginationInfo };
}